module.exports = "pegasus/assets/blocks/image-1-theme4.png";